const IST_TIME_ZONE = "Asia/Kolkata";

const hasTimezone = (value) => /([zZ]|[+-]\d{2}:?\d{2})$/.test(String(value).trim());

const parseApiDate = (value) => {
  if (!value) {
    return null;
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === "number") {
    return new Date(value);
  }

  const normalized = String(value).trim().replace(" ", "T");
  return new Date(hasTimezone(normalized) ? normalized : normalized + "Z");
};

export const formatIstDateTime = (value, options = {}) => {
  const date = parseApiDate(value);

  if (!date || Number.isNaN(date.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIME_ZONE,
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    ...options,
  }).format(date).replace(/\b(am|pm)\b/i, (match) => match.toUpperCase());
};

export const formatIstFullDateTime = (value) => (
  formatIstDateTime(value, { year: "numeric" })
);

export const formatIstDate = (value) => {
  const date = parseApiDate(value);

  if (!date || Number.isNaN(date.getTime())) {
    return "-";
  }

  return new Intl.DateTimeFormat("en-IN", {
    timeZone: IST_TIME_ZONE,
    day: "2-digit",
    month: "short",
  }).format(date).replace(",", "");
};
